export default class N2StylesModal {
  constructor(selector, opts={}) {
    if (!opts.skip_init) {
      this.initModal(selector);
    }
  }

  initModal(selector) {
    $(selector).modal();
    $('.modal-backdrop').addClass('in');
  }
}
